export default __webpack_public_path__ + "static/media/microwave.b9d60a76.png";